module.exports = __webpack_public_path__ + "7233c36211f5fa90c86097203e55bbfd.svg";